<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data:function () {
    return{
		isRouter:false
    }
  },
}
</script>

<style>
@import './assets/css/main.css';
body {
    background-color: transparent !important;
}
</style>
